import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import {
  genericRequiredFieldError,
  RELATED_PARTY_TYPES,
} from '../../constants';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';

const {
  formField: { principalType, principalTrustName },
} = loanFormModel;

export class PrincipalTrustNameValidation implements ValidationSchema {
  public name = principalTrustName.name;
  public label = principalTrustName.label;
  public dependsOn: string[] = [principalType.name];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  public when(principalType: string, schema) {
    if (principalType === RELATED_PARTY_TYPES.ENTITY) {
      return schema.required(genericRequiredFieldError);
    }
    return schema.notRequired();
  }
}
export default new Validation(new PrincipalTrustNameValidation());
